import { createTrackStandaloneEventHook } from './useTrackStandaloneEvent';
export const useTrackSearchResultClicked = createTrackStandaloneEventHook('Search Result Clicked');